/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from './themes/ScrollBarStyles.css';

type ScrollBarProps = {
  viewport: { viewportMin: number; viewportMax: number };
  axisExtent: { min: number; max: number };
  availSpace: { x: number; y: number; width: number; height: number };
  isHoriz: boolean;
};

const SCROLLBAR_SIZE = 3;
export function ScrollBar({ viewport, axisExtent, availSpace, isHoriz }: ScrollBarProps) {
  const axisRange = axisExtent.max - axisExtent.min;

  const viewportStartOffset = viewport.viewportMin - axisExtent.min;
  const viewportRange = viewport.viewportMax - viewport.viewportMin;

  const height = isHoriz ? SCROLLBAR_SIZE : availSpace.height;
  const width = isHoriz ? availSpace.width : SCROLLBAR_SIZE;
  const x = isHoriz ? availSpace.x : availSpace.x + availSpace.width - width / 2;
  const y = !isHoriz ? availSpace.y : availSpace.y + availSpace.height - height / 2;

  const x1 = isHoriz ? x + (availSpace.width * viewportStartOffset) / axisRange : x;
  const w1 = isHoriz ? (availSpace.width * viewportRange) / axisRange : SCROLLBAR_SIZE;

  const y1 = isHoriz ? y : y + (availSpace.height * viewportStartOffset) / axisRange;
  const h1 = isHoriz ? SCROLLBAR_SIZE : (availSpace.height * viewportRange) / axisRange;

  return (
    <g>
      <rect x={x} y={y} width={width} height={height} class={styles.scrollBarTrack}></rect>
      <rect x={x1} y={y1} width={w1} height={h1} class={styles.scrollBar}></rect>
      <rect {...availSpace} class={styles.scrollBarSpace}></rect>
    </g>
  );
}
